import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * 管理者（ROLE_MANAGER）のみアクセス可能なルートのガード。
 * 店員（CLERK）が直接 URL でアクセスした場合は /home へリダイレクトする。
 * 最終的な権限強制は BE が行い、本ガードは画面遷移の抑止（UX）を担う。feast-fe ADR 0013。
 */
const RequireManager: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const isManager = localStorage.getItem('role') === 'ROLE_MANAGER';
  if (!isManager) {
    return <Navigate to="/home" replace />;
  }
  return children;
};

export default RequireManager;
